import React from "react";
import "../assets/css/pageHeader.css";

/**
 * Slim page title bar. Reusable across every page.
 *
 * Title and subtitle sit on one line (subtitle is dropped on narrow screens
 * rather than wrapping), keeping the bar ~52px tall so the grid below gets
 * the vertical space.
 *
 * Props:
 *   icon?     : node   — small glyph shown before the title
 *   title     : string — page title
 *   subtitle? : string — one-line description, shown inline after a separator
 *   actions?  : node   — right-side controls (filters, buttons, …)
 */
const PageHeader = ({ icon, title, subtitle, actions, className }) => {
  return (
     <div className={`page-header ${className}`}>
      <div className="page-header__left">
        {icon && <span className="page-header__icon">{icon}</span>}
        <h2 className="page-header__title">{title}</h2>
        {subtitle && (
          <>
            <span className="page-header__sep" aria-hidden="true" />
            <span className="page-header__subtitle">{subtitle}</span>
          </>
        )}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
};

export default PageHeader;
